/**
 * Component - uspLine
 */

// Sub-components

export const uspLine = ():void => {
  // Run the script for each individual component found on the page
  const componentSelector = document.querySelectorAll('.js-uspLine') as unknown as HTMLElement[]
  componentSelector.forEach((component:HTMLElement) => {
  })
}
